import { ImageDefinition } from '../ImageDefinition'
import { ParagraphDefinition } from '../ParagraphDefinition'
import ComponentType from './ComponentType'

export enum ContentColumnType {
  Image = 'IMAGE',
  Text = 'PARAGRAPH'
}

interface ImageColumnDefinition extends ImageDefinition {
  type: ContentColumnType.Image
}

interface TextColumnDefinition extends ParagraphDefinition {
  type: ContentColumnType.Text
}

export type ContentColumnDefinition =
  | ImageColumnDefinition
  | TextColumnDefinition

export interface ContentColumnsComponentDefinition {
  backgroundImage?: ImageDefinition
  type: ComponentType.ContentColumns
  columns: ContentColumnDefinition[]
  comment?: string
}
